import { useState } from 'react';

const testimonials = [
  {
    text: "Doolittle Air saved the day! Our AC went out during a heatwave and they came out the same day. The technician was professional, explained everything clearly, and had us up and running in no time. Highly recommend!",
    name: "Sarah Mitchell",
    location: "Sarasota, FL",
    rating: 5,
    date: "2 weeks ago",
    avatar: "SM"
  },
  {
    text: "We've been using Doolittle Air for years for our maintenance and they're always on time, professional, and thorough. Their upfront pricing is refreshing — no surprises. They truly care about their customers.",
    name: "Robert Johnson",
    location: "Venice, FL",
    rating: 5,
    date: "1 month ago",
    avatar: "RJ"
  },
  {
    text: "Best HVAC company in the area! They installed a new AC system in our home and the process was seamless. Fair pricing, quality work, and excellent customer service. You can tell they're a family business that cares.",
    name: "Maria Rodriguez",
    location: "Nokomis, FL",
    rating: 5,
    date: "3 weeks ago",
    avatar: "MR"
  },
  {
    text: "Called Doolittle Air for an emergency repair on a Sunday and they actually answered! The technician arrived quickly, diagnosed the problem, and fixed it efficiently. Their diagnostic fee was waived with the repair. Fantastic service!",
    name: "David Thompson",
    location: "Osprey, FL",
    rating: 5,
    date: "1 month ago",
    avatar: "DT"
  },
  {
    text: "After getting quotes from several companies, Doolittle Air offered the best value and service. They took time to explain our options and didn't pressure us. The installation team was respectful and cleaned up perfectly. Very satisfied!",
    name: "Jennifer Lee",
    location: "North Port, FL",
    rating: 5,
    date: "2 months ago",
    avatar: "JL"
  },
  {
    text: "I appreciate honest businesses and Doolittle Air is exactly that. They could have sold me a new unit but instead repaired my existing one for a fraction of the cost. That's integrity. They've earned a customer for life.",
    name: "Michael Brown",
    location: "Sarasota, FL",
    rating: 5,
    date: "3 months ago",
    avatar: "MB"
  }
];

const ratingBreakdown = [
  { stars: 5, count: 89, pct: 92 },
  { stars: 4, count: 6,  pct: 6  },
  { stars: 3, count: 1,  pct: 1  },
  { stars: 2, count: 0,  pct: 0  },
  { stars: 1, count: 1,  pct: 1  },
];

function StarRow({ rating }: { rating: number }) {
  return (
    <div className="flex gap-0.5">
      {[1, 2, 3, 4, 5].map((s) => (
        <i
          key={s}
          className={`ri-star-fill text-base ${s <= rating ? 'text-orange-500' : 'text-gray-200'}`}
        />
      ))}
    </div>
  );
}

export default function Testimonials() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const visibleCount = 3;
  const maxIndex = testimonials.length - visibleCount;

  return (
    <section className="py-24 bg-[#fafaf8]">
      <div className="max-w-7xl mx-auto px-6">

        {/* Header */}
        <div className="text-center mb-14">
          <p className="text-orange-500 font-semibold text-sm uppercase tracking-widest mb-3">
            Verified Customer Reviews
          </p>
          <h2 className="text-5xl font-bold text-slate-900 mb-4">
            What Our Customers Say
          </h2>
          <p className="text-gray-500 text-lg max-w-xl mx-auto">
            Real reviews from real homeowners across Sarasota &amp; surrounding areas.
          </p>
        </div>

        {/* Social Proof Summary Bar */}
        <div className="bg-white rounded-3xl shadow-md p-8 mb-14 flex flex-col md:flex-row items-center gap-10">

          {/* Overall Score */}
          <div className="flex flex-col items-center min-w-[160px]">
            <div className="flex items-center gap-2 mb-1">
              <img
                src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 48 48'%3E%3Cpath fill='%234285F4' d='M44.5 20H24v8.5h11.8C34.7 33.9 30.1 37 24 37c-7.2 0-13-5.8-13-13s5.8-13 13-13c3.1 0 5.9 1.1 8.1 2.9l6.4-6.4C34.6 4.1 29.6 2 24 2 11.8 2 2 11.8 2 24s9.8 22 22 22c11 0 21-8 21-22 0-1.3-.2-2.7-.5-4z'/%3E%3C/svg%3E"
                alt="Google"
                className="w-6 h-6"
              />
              <span className="text-sm font-semibold text-gray-500 uppercase tracking-wide">Google</span>
            </div>
            <p className="text-7xl font-extrabold text-slate-900 leading-none">4.9</p>
            <div className="flex gap-1 my-2">
              {[1,2,3,4,5].map((s) => (
                <i key={s} className="ri-star-fill text-xl text-orange-500" />
              ))}
            </div>
            <p className="text-gray-500 text-sm">Based on <strong className="text-slate-800">97 reviews</strong></p>
          </div>

          {/* Divider */}
          <div className="hidden md:block w-px h-32 bg-gray-200" />

          {/* Rating Breakdown */}
          <div className="flex-1 w-full space-y-2">
            {ratingBreakdown.map(({ stars, count, pct }) => (
              <div key={stars} className="flex items-center gap-3">
                <span className="text-sm text-gray-500 w-6 text-right">{stars}</span>
                <i className="ri-star-fill text-orange-400 text-sm" />
                <div className="flex-1 bg-gray-100 rounded-full h-2.5 overflow-hidden">
                  <div
                    className="h-full bg-orange-400 rounded-full transition-all duration-700"
                    style={{ width: `${pct}%` }}
                  />
                </div>
                <span className="text-sm text-gray-400 w-6">{count}</span>
              </div>
            ))}
          </div>

          {/* Divider */}
          <div className="hidden md:block w-px h-32 bg-gray-200" />

          {/* Trust Badges */}
          <div className="flex flex-col gap-4 min-w-[180px]">
            {[
              { icon: 'ri-shield-check-fill', label: 'Licensed & Insured' },
              { icon: 'ri-thumb-up-fill',     label: '100% Satisfaction' },
              { icon: 'ri-map-pin-2-fill',    label: 'Local Family Business' },
            ].map(({ icon, label }) => (
              <div key={label} className="flex items-center gap-3">
                <div className="w-9 h-9 flex items-center justify-center rounded-full bg-orange-50">
                  <i className={`${icon} text-orange-500 text-lg`} />
                </div>
                <span className="text-sm font-semibold text-slate-700">{label}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Testimonial Cards Carousel */}
        <div className="relative overflow-hidden mb-10">
          <div
            className="flex transition-transform duration-500 ease-in-out gap-6"
            style={{ transform: `translateX(-${currentIndex * (100 / visibleCount + 2)}%)` }}
          >
            {testimonials.map((t, i) => (
              <div
                key={i}
                className="flex-shrink-0 w-full md:w-[calc(33.333%-16px)] bg-white rounded-3xl p-8 shadow-md hover:shadow-xl transition-shadow flex flex-col justify-between"
              >
                {/* Top row */}
                <div>
                  <div className="flex items-center justify-between mb-5">
                    <StarRow rating={t.rating} />
                    <div className="flex items-center gap-1.5 bg-green-50 text-green-600 text-xs font-semibold px-2.5 py-1 rounded-full">
                      <i className="ri-checkbox-circle-fill text-sm" />
                      Verified
                    </div>
                  </div>
                  <p className="text-gray-700 text-base leading-relaxed italic mb-6">
                    &ldquo;{t.text}&rdquo;
                  </p>
                </div>

                {/* Bottom row */}
                <div className="flex items-center gap-3 pt-4 border-t border-gray-100">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-orange-500 text-white font-bold text-sm flex-shrink-0">
                    {t.avatar}
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="font-bold text-slate-900 text-sm truncate">{t.name}</p>
                    <p className="text-gray-400 text-xs">{t.location} · {t.date}</p>
                  </div>
                  <img
                    src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 48 48'%3E%3Cpath fill='%234285F4' d='M44.5 20H24v8.5h11.8C34.7 33.9 30.1 37 24 37c-7.2 0-13-5.8-13-13s5.8-13 13-13c3.1 0 5.9 1.1 8.1 2.9l6.4-6.4C34.6 4.1 29.6 2 24 2 11.8 2 2 11.8 2 24s9.8 22 22 22c11 0 21-8 21-22 0-1.3-.2-2.7-.5-4z'/%3E%3C/svg%3E"
                    alt="Google Review"
                    className="w-5 h-5 flex-shrink-0"
                  />
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Navigation Dots */}
        <div className="flex justify-center gap-3 mb-12">
          {Array.from({ length: maxIndex + 1 }).map((_, i) => (
            <button
              key={i}
              onClick={() => setCurrentIndex(i)}
              className={`h-3 rounded-full transition-all cursor-pointer ${
                currentIndex === i ? 'bg-orange-500 w-8' : 'bg-gray-300 w-3'
              }`}
              aria-label={`Go to review ${i + 1}`}
            />
          ))}
        </div>

        {/* Leave a Review CTA */}
        <div className="text-center">
          <p className="text-gray-500 mb-4 text-sm">Happy with our service? Let others know!</p>
          <a
            href="https://g.page/r/review"
            target="_blank"
            rel="noopener noreferrer nofollow"
            className="inline-flex items-center gap-2 bg-slate-900 hover:bg-slate-700 text-white font-semibold px-7 py-3.5 rounded-full transition-colors cursor-pointer whitespace-nowrap"
          >
            <img
              src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 48 48'%3E%3Cpath fill='%23fff' d='M44.5 20H24v8.5h11.8C34.7 33.9 30.1 37 24 37c-7.2 0-13-5.8-13-13s5.8-13 13-13c3.1 0 5.9 1.1 8.1 2.9l6.4-6.4C34.6 4.1 29.6 2 24 2 11.8 2 2 11.8 2 24s9.8 22 22 22c11 0 21-8 21-22 0-1.3-.2-2.7-.5-4z'/%3E%3C/svg%3E"
              alt="Google"
              className="w-4 h-4"
            />
            Leave Us a Google Review
            <i className="ri-external-link-line text-sm" />
          </a>
        </div>

      </div>
    </section>
  );
}
